import { ErrorResponseType } from 'entities/common';
import { UserResponse } from 'services/auth';
import {
  GET_CURRENT_USER_FAILURE,
  GET_CURRENT_USER_REQUEST,
  GET_CURRENT_USER_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
} from './Auth.constant';
import { AuthActionsTypes } from './Auth.type';

export const loginRequest = (username: string, password: string): AuthActionsTypes => ({
  type: LOGIN_REQUEST,
  payload: { username, password },
});

export const loginSuccess = (token: string): AuthActionsTypes => ({
  type: LOGIN_SUCCESS,
  payload: { token },
});

export const loginFailure = (error: ErrorResponseType): AuthActionsTypes => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const logout = () => ({
  type: LOGOUT,
});

export const getCurrentUserRequest = () => ({
  type: GET_CURRENT_USER_REQUEST,
});

export const getCurrentUserSuccess = (user: UserResponse): AuthActionsTypes => ({
  type: GET_CURRENT_USER_SUCCESS,
  payload: user,
});

export const getCurrentUserFailure = (error: ErrorResponseType): AuthActionsTypes => ({
  type: GET_CURRENT_USER_FAILURE,
  payload: error,
});
